const offPatternColors = {
  shadowDark: "rgba(0, 0, 0, 0.15)",
  shadowDarker: "rgba(0, 0, 0, 0.22)",
  grayDark: "#2E2E38",
};

const zIndexValues = {
  z70: 70,
  z80: 80,
  z90: 90,
  z100: 100,
};

const localStorageKeys = {
  accountselector: {
    context: "appshell-accountselector",
    names: {
      hideSelectorModal: "hide-selector-modal",
    },
  },
};

export { offPatternColors, zIndexValues, localStorageKeys };
